class MyStoreDescriptionCarousel {
  constructor(root) {
    this.root = root;
    this.images = [...root.querySelectorAll('img')].filter((image) => !image.closest('.mp-desc-carousel'));
    if (!this.images.length) return;
    this.index = 0;
    this.build();
  }

  build() {
    const firstImage = this.images[0];
    const insertionPoint = this.getImageContainer(firstImage);
    this.carousel = document.createElement('section');
    this.carousel.className = `mp-desc-carousel${this.images.length === 1 ? ' mp-desc-carousel--single' : ''}`;
    this.carousel.setAttribute('aria-label', 'Galería de imágenes de la descripción');

    const viewport = document.createElement('div');
    viewport.className = 'mp-desc-carousel__viewport';
    this.track = document.createElement('div');
    this.track.className = 'mp-desc-carousel__track';

    this.images.forEach((source, index) => {
      const slide = document.createElement('figure');
      slide.className = 'mp-desc-carousel__slide';
      slide.dataset.index = String(index);
      const image = source.cloneNode(true);
      image.removeAttribute('width');
      image.removeAttribute('height');
      image.loading = index === 0 ? 'eager' : 'lazy';
      image.decoding = 'async';
      const captionText = source.getAttribute('alt');
      slide.append(image);
      if (captionText) {
        const caption = document.createElement('figcaption');
        caption.textContent = captionText;
        slide.append(caption);
      }
      this.track.append(slide);
    });

    viewport.append(this.track);
    this.carousel.append(viewport);

    if (this.images.length > 1) {
      const previous = this.button('previous', 'Imagen anterior', '←');
      const next = this.button('next', 'Imagen siguiente', '→');
      this.carousel.append(previous, next);

      const footer = document.createElement('div');
      footer.className = 'mp-desc-carousel__footer';
      this.counter = document.createElement('span');
      this.counter.className = 'mp-desc-carousel__counter';
      this.counter.innerHTML = `<b>01</b><i></i><span>${String(this.images.length).padStart(2, '0')}</span>`;
      this.dots = document.createElement('div');
      this.dots.className = 'mp-desc-carousel__dots';
      this.images.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Ver imagen ${index + 1}`);
        dot.addEventListener('click', () => this.goTo(index));
        this.dots.append(dot);
      });
      footer.append(this.counter, this.dots);
      this.carousel.append(footer);

      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          const nextIndex = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (nextIndex !== this.index) this.update(nextIndex, false);
        });
      }, { passive: true });
      this.carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
        if (event.key === 'ArrowRight') this.goTo(this.index + 1);
      });
      this.carousel.tabIndex = 0;
    }

    insertionPoint.before(this.carousel);
    this.images.forEach((image) => {
      const container = this.getImageContainer(image);
      container.classList.add('mp-description-original-image');
      container.setAttribute('aria-hidden', 'true');
    });
    this.update(0, false);
  }

  getImageContainer(image) {
    const parent = image.parentElement;
    if (parent && ['P', 'FIGURE'].includes(parent.tagName) && parent.textContent.trim() === '') return parent;
    if (parent?.tagName === 'A' && parent.parentElement?.tagName === 'P' && parent.parentElement.textContent.trim() === '') return parent.parentElement;
    return image;
  }

  button(direction, label, symbol) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `mp-desc-carousel__arrow mp-desc-carousel__arrow--${direction}`;
    button.setAttribute('aria-label', label);
    button.innerHTML = `<span>${symbol}</span>`;
    button.addEventListener('click', () => this.goTo(this.index + (direction === 'next' ? 1 : -1)));
    return button;
  }

  goTo(index) {
    const normalized = (index + this.images.length) % this.images.length;
    this.update(normalized, true);
  }

  update(index, scroll) {
    this.index = Math.max(0, Math.min(index, this.images.length - 1));
    if (scroll) this.track.scrollTo({ left: this.track.clientWidth * this.index, behavior: 'smooth' });
    if (this.counter) this.counter.querySelector('b').textContent = String(this.index + 1).padStart(2, '0');
    this.dots?.querySelectorAll('button').forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === this.index);
      dot.setAttribute('aria-current', dotIndex === this.index ? 'true' : 'false');
    });
  }
}

document.querySelectorAll('[data-mp-description-carousel="true"]').forEach((root) => new MyStoreDescriptionCarousel(root));
